import React from 'react'
import classNames from 'classnames'
import { format } from 'date-fns'
import { Avatar, StarRating } from '@deal/components'
import { isExpertPresent } from '#src/services/presence'
import { ConsumerExpertReviewFragment } from '#src/generated/graphql'
import { Link } from 'react-router-dom'
import styles from './styles.css'
import VerifiedPurchaseCard from '#src/components/VerifiedPurchaseCard'

interface CardProps {
  className?: string
}

interface ActivityFeedCardProps extends CardProps {
  activityFeedItem: ConsumerExpertReviewFragment
}

const NoActivityCard: React.SFC<CardProps> = ({ className, children }) => {
  return (
    <div className={classNames(styles.item, className)}>
      <div className={styles.itemContent}>
        <div className={styles.noActivity}>{children}</div>
      </div>
    </div>
  )
}

const ActivityFeedCard: React.SFC<ActivityFeedCardProps> = ({ activityFeedItem, className }) => {
  const verifiedPurchases = activityFeedItem.verifiedPurchases

  const expertPhoto = activityFeedItem.expert.expertProfile
    ? activityFeedItem.expert.expertProfile.profilePhoto
    : null

  return (
    <div className={classNames(styles.item, className)}>
      <div className={styles.itemHeader}>
        <div className={styles.avatarContainer}>
          <Link to={`/experts/${activityFeedItem.expert.vanityId || activityFeedItem.expert.id}`}>
            <Avatar
              name={activityFeedItem.expert.displayName}
              src={expertPhoto ? expertPhoto.url : undefined}
            />
          </Link>
          {isExpertPresent(activityFeedItem.expert) && <div className={styles.presenceBadge} />}
        </div>

        <div className={styles.headerDetails}>
          <div>
            Expert:{' '}
            <Link
              to={`/experts/${activityFeedItem.expert.vanityId || activityFeedItem.expert.id}`}
              className={styles.expertName}
            >
              {activityFeedItem.expert.displayName}
            </Link>
          </div>
          <div className={styles.reviewer}>Reviewer: {activityFeedItem.consumerName}</div>
        </div>
      </div>

      <div className={styles.itemContent}>
        <div>
          <div className={styles.reviewHeader}>
            <div className={styles.reviewHeaderStars}>
              <StarRating rating={activityFeedItem.rating} />
            </div>
            <span className={styles.reviewHeadline}>
              {activityFeedItem.headline
                ? activityFeedItem.headline
                : `${activityFeedItem.consumerName}'s experience with ${activityFeedItem.expert.shortName}`}
            </span>
          </div>
          {activityFeedItem.comments && (
            <div
              className={styles.reviewBody}
              dangerouslySetInnerHTML={{
                __html: activityFeedItem.comments
              }}
            />
          )}
          <div className={styles.reviewFooter}>
            Verified Review | Submitted {format(activityFeedItem.reviewedAt, 'MMM d, YYYY')}
          </div>
          {verifiedPurchases.length > 0 && (
            <div className={styles.reviewSellablesContainer}>
              <div className={styles.reviewSellables}>
                {verifiedPurchases.map((sellable, idx) => (
                  <VerifiedPurchaseCard key={idx} sellable={sellable} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { NoActivityCard }

export default ActivityFeedCard
